// src/components/common/DeleteConfirmModal/DeleteConfirmModal.jsx
import "./deleteConfirmModal.scss";

const DeleteConfirmModal = ({
  show,
  title = "Delete Item",
  message,
  itemName,
  onConfirm,
  onCancel,
  loading = false,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
}) => {
  if (!show) return null;

  const defaultMessage = itemName
    ? `Are you sure you want to delete "${itemName}"? This action cannot be undone.`
    : "Are you sure you want to delete this item? This action cannot be undone.";

  return (
    <div className="delete-confirm-overlay" role="dialog" aria-modal="true">
      <div className="delete-confirm-box">
        <h4 className="delete-confirm-box__title">{title}</h4>
        <p className="delete-confirm-box__message">{message || defaultMessage}</p>
        <div className="delete-confirm-box__actions">
          <button
            type="button"
            className="delete-confirm-box__btn delete-confirm-box__btn--cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="delete-confirm-box__btn delete-confirm-box__btn--confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;